'use strict';

const Mn = require('backbone.marionette');
const Template = require('system/ui/template/modal/shortcut.hbs');

module.exports = Mn.View.extend({
    template: Template,
    events: {
        'click .close': 'remove'
    },

    show: function() {
        this.$('.modal').modal('show');
    },

    hide: function() {
        this.$('.modal').modal('hide');
        this.remove();
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/modal/shortcut.js